/**
 * The value used to indicate that the sequence in/out point is not set.
 */
export const POINT_NOT_SET_VALUE = -400000;
